import React,{ useState,useEffect } from 'react'
import "../pages/styles.css"
import Header from '../components/header'
import markersection from "../assets/home/markersection.png";
import ghq4 from "../assets/home/ghq4.png";
import resume7 from "../assets/resume/7a9132a1-fa90-4758-a24c-220316b93648.jpg";
import Button from '@mui/material/Button';
import axios from 'axios';
import Footer from "../components/Footer"
import { useSelector, useDispatch } from "react-redux";
import { loginModal } from "../Redux/authAction";
import apiConfig from '../config/api.js';


const Catelog = () => {
    const [data, setData] = useState([]);
    const [img, setImg] = useState(`${markersection}`);
    const isLang = useSelector((state) => state.authReducer.lang);


    const isAuthenticated = useSelector(
        (state) => state.authReducer.isAuthenticated
      );
      const dispatch = useDispatch();

      const handleOpen = () => {
        dispatch(loginModal(true))
        setOpenModel(false);
      };
      const handelOpenModel = () => {
        dispatch(loginModal(false))
        setOpenModel(true);
      };
      const handleClose = () => {
        dispatch(loginModal(false)) 
        dispatch(loginModal(false))
      };
      const handleCloseModel = () => setOpenModel(false);
      const [openModel, setOpenModel] = useState(false);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(
                    `${apiConfig.API_URL}/aapi/tempbycat.php?title=Promotion Maker`
                  );
                setData(response.data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);


    console.log("data-=-=-=-",data)
  return (
    <>
    <Header />
    <div  className='pt-20 bg-purple-600' >

    <div className='catlogContainer'>
  <div>
    {isLang === 'eng' ? (
      <>
        <p>Turn Your Photo to Sketch Promotion Maker</p>
        <br />
        <p>
          Elevate your images to stunning pencil sketches with Fotor's photo to sketch converter.
          Let our magic sketch filter artify your images effortlessly in just one click!
        </p>
        <br />
        <p>
          Elevate your images to stunning pencil sketches with Fotor's photo to sketch converter.
          Let our magic sketch filter artify your images effortlessly in just one click!
        </p>
        <br />
        <p>
          Elevate your images to stunning pencil sketches with Fotor's photo to sketch converter.
          Let our magic sketch filter artify your images effortlessly in just one click!
        </p>
      </>
    ) : (
      <>
        <p>دفع الحدود لتصور تجارب غير عادية</p>
        <br />
        <p>
          يسمح لك صانع الإعلانات الترويجية في Maker4U بتحويل لافتة وصور علامتك التجارية بسرعة وسهولة
          إلى لافتة ترويجية مذهلة وقوية أو عرض شرائح أو فيديو تجاري لجذب العملاء المحتملين.
        </p>
        <br />
        <p>
          بغض النظر عن الجمهور المستهدف لمبيعات أعمالك الترويجية أو مواقع الويب أو الحملات. يقدم لك Maker4U
          مكتبة واسعة من النماذج الترويجية ذات الصلة.
        </p>
        <br />
        <p>
          تحقق من النص المدمج والتأثيرات والمقدمات والخاتمة وموسيقى الخلفية لرفع شعارك الترويجي إلى المستوى الذي
          يليق بالمحترف.
        </p>
      </>
    )}
  </div>

  <div></div>

  <div>
    <img src={`${markersection}`} alt="Promotion Maker" />
  </div>
</div>


    </div>
    <div>
  {/* Title Section */}
  <p className='text-[32px] text-center font-[500] mt-10'>
    {isLang === 'eng' ? 'Turn Photo into Sketch Using AI Sketch Filters & Effects' : 'تحويل الصورة إلى رسم باستخدام مرشحات التأثيرات والرسم بالذكاء الاصطناعي'}
  </p>

  {/* Description Section */}
  <div className='flex justify-center text-lg'>
    <div className='text-center' style={{ maxWidth: "1200px" }}>
      <p>
        {isLang === 'eng' ? 
          `Use our professionally crafted sketch filters and effects to give your photos a lifelike sketching look. Our easy-to-use online photo to sketch converter only takes a couple of seconds to turn a photo into a sketch drawing, with no manual editing. Whether you want to sketch faces, landscapes, or pets, Fotor has you covered!` : 
          `استخدم مرشحات الرسم والمؤثرات المصممة باحترافية لإعطاء صورك مظهراً حقيقياً وكأنها مرسومة. محول الصور إلى رسومات الخاص بنا سهل الاستخدام عبر الإنترنت ولا يستغرق سوى بضع ثوانٍ لتحويل الصورة إلى رسم بدون تحرير يدوي. سواء كنت تريد رسم الوجوه أو المناظر الطبيعية أو الحيوانات الأليفة، فإن Fotor يغطيك!`
        }
      </p>
    </div>
  </div>

  {/* Promotion Section */}
  <div className='flex justify-center text-lg'>
    <div className='text-center' style={{ maxWidth: "1200px", marginTop: "20px" }}>
      <p>{isLang === 'eng' ? 'A Wide Range of Outstanding Promotion Templates for Free' : 'مكتبة واسعة من نماذج الترويج المتميزة مجانًا'}</p>
      <p>
        {isLang === 'eng' ? 
          `This is the perfect place to be if you need an image or video for your website, social networking, company promotion, or advertisements! We have an extensive collection of well-created image and video templates. We can help with everything from social media postings to website promotions and marketing clips.` : 
          `هذا هو المكان المثالي إذا كنت بحاجة إلى صورة أو مقطع فيديو لموقعك الألكتروني أو شبكات التواصل الاجتماعي أو الترويج لشركتك أو إعلاناتك! لدينا مكتبة واسعة من نماذج الصور والفيديو المنشأة بعناية. يمكننا المساعدة في كل شيء بدءاً من منشورات وسائل التواصل الاجتماعي وحتى العروض الترويجية لموقع الويب والمقاطع التسويقية.`
        }
      </p>
    </div>
  </div>
</div>

<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
  {data.map((item) => (
    <div key={item.id} className="card">
      <img
        src={`${apiConfig.API_URL}/aapi/templetes/${item.imagepath}`}
        alt={item.title}
        className="w-full h-auto"
      />
      <div className="card-content text-center">
        <h3 className="text-lg font-medium">{item.title}</h3>
      </div>
    </div>
  ))}
</div>


            {/* <Button variant="contained" onClick={handleOpen}  style={{marginTop:"10px",width:"180px",borderRadius:"30px", background:  "linear-gradient(to right, #714e91 0%, #5f619f  51%, #433761  100%"}}>SHOW MORE</Button> */}

            
    <p className='my-16 text-[32px] text-center font-[500]' >Turn Photo into Sketch Using AI Sketch Filters & Effects</p>


<div className='imageGrid' style={{display: 'flex',  justifyContent:'center', alignItems:'center'}}>
    <div>
        <img src={`${img}`} />
    </div>
    <div>
        <div onClick={()=> setImg(`${markersection}`)}>
            <img src={`${markersection}`} />
        </div>
        <div onClick={()=> setImg(`${ghq4}`)}>
             <img src={`${ghq4}`} />
             </div>
        <div onClick={()=> setImg(`${resume7}`)}>
        <img src={`${resume7}`} />
        </div>
    </div>
</div>


<div className='catelogTextContainer'>

  {/* Marketing Section */}
  <div className='catelogText' style={{marginTop: '20px'}}>
    <p>
      {isLang === 'eng' ? 
        'Only marketing media maker your brand will ever require!' : 
        'صانع الوسائط التسويقية الوحيد الذي ستحتاجه علامتك التجارية!'
      }
    </p>
    <p>
      {isLang === 'eng' ? 
        'Get into the festive mood with a professionally produced advertising banner. Tell viewers why giving your items as gifts to friends and family for the holidays will be a fantastic idea.' : 
        'اشعر بالمزاج الاحتفالي باستخدام لافتة إعلانية انتجت بشكل احترافي. أخبر المشاهدين لماذا سيكون تقديم العناصر الخاصة بك كهدايا للأصدقاء والعائلة في العطلات فكرة رائعة.'
      }
    </p>
    <p>
      {isLang === 'eng' ? 
        'You can also create 15-second video ads and give your audience a taste of your offering. A brief product introduction gives your viewers enough information to grab their attention and persuade them to click through.' : 
        'يمكنك أيضًا إنشاء إعلانات فيديو مدته 15 ثانية ومنح جمهورك لمحة عن عروضك. توفر المقدمة الموجزة للمنتج للمشاهدين ما يكفي من المعلومات لجذب انتباههم وإقناعهم بالنقر عليه.'
      }
    </p>
    <p>
      {isLang === 'eng' ? 
        'An effective marketing promotional flyer or banner allows all audiences to recognize your business immediately, and Maker4U is the simplest stop to create one.' : 
        'تسمح النشرة أو اللافتة الترويجية التسويقية الفعالة لجميع الجماهير بالتعرف على عملك على الفور، وMaker4U هو أبسط مكان لإنشائها.'
      }
    </p>
  </div>
</div>

<div className='catlogSection'>
    <div>
        <img src={`${markersection}`} />
    </div>
    <div></div>
    <div>
        <p>Make Innovative Marketing Campaigns to Boost Sales</p>
        <p>A sales banner must be imaginative enough to draw viewers in and make a lasting impression. An effective marketing promotional banner allows all audiences to recognize your business immediately, and Maker4U is the simplest website to create one. Create buzz about the event and encourage people to come with a promo. Direct visitors from a business promotion banner to a sign-up page in only a few seconds.</p>
        <button 
  onClick={handleOpen} 
  style={{ 
    marginTop: "10px", 
    width: "180px", 
    borderRadius: "30px", 
    backgroundColor: "#6d28d9", // Tailwind's purple-600 hex color
    color: "white",
    border: "none",
    padding: "10px 20px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
    textAlign: "center",
  }}
>
  Try Now
</button>
    </div>
</div>



<div className='catlogSectionTwo'>
  <div>
    <img src={`${markersection}`} alt="Promotion" />
  </div>
  <div></div>
  <div>
    {isLang === 'eng' ? (
      <>
        <p>Create Engaging Advertisements to Expand Brands</p>
        <p>Make your viewers feel involved, and they will be more inclined to learn and convert if you make your Ad pictures entertaining. There is no better approach to promote your values and develop your brand than through a unique business promotion clip. With the aid of Maker4U, you can create cinematic Ads for Twitter, Facebook, YouTube, and other platforms.</p>
        <button 
  onClick={handleOpen} 
  style={{ 
    marginTop: "10px", 
    width: "180px", 
    borderRadius: "30px", 
    backgroundColor: "#6d28d9", // Tailwind's purple-600 hex color
    color: "white",
    border: "none",
    padding: "10px 20px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
    textAlign: "center",
  }}
>
  Try Now
</button>

      </>
    ) : (
      <>
        <p>أنشئ إعلانات جذابة لتوسيع العلامات التجارية</p>
        <p>قم باشراك المشاهدين، سيجعلهم ذلك أكثر ميلاً للتعلم والتحويل إذا جعلت صور إعلانك ممتعة. لا يوجد نهج أفضل لتعزيز قيمك وتطوير علامتك التجارية من خلال مقطع أعمال ترويجي فريد. بمساعدة Maker4U، يمكنك إنشاء إعلانات سينمائية لـ Twitter وFacebook وYouTube وغيرها من المنصات.</p>
        <button 
  onClick={handleOpen} 
  style={{ 
    marginTop: "10px", 
    width: "180px", 
    borderRadius: "30px", 
    backgroundColor: "#6d28d9", // Tailwind's purple-600 hex color
    color: "white",
    border: "none",
    padding: "10px 20px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
    textAlign: "center",
  }}
>
جرب الآن
</button>
      </>
    )}
  </div>
</div>


<div className='catlogSection'>
  <div>
    <img src={`${markersection}`} alt="Promotion" />
  </div>
  <div></div>
  <div>
    {isLang === 'eng' ? (
      <>
        <p>Make Eye-Catching Videos to Promote and Market Your Business.</p>
        <p>Make visually appealing graphics in a matter of minutes! Maker4U's promo creator provides hundreds of professionally designed promotion templates that anybody can easily edit in minutes. No prior design knowledge is required.</p>
      </>
    ) : (
      <>
        <p>أنشئ مقاطع فيديو لافتة للنظر للترويج لشركتك وتسويقها.</p>
        <p>قم بإنشاء رسومات جذابة بصريًا في غضون دقائق! يوفر منشئ العرض الترويجي لـ Maker4U المئات من نماذج الترويج المصممة بشكل احترافي والتي يمكن لأي شخص تعديلها بسهولة في دقائق. لا تحتاج لمعرفة مسبقة بالتصميم.</p>
      </>
    )}
     <button 
  onClick={handleOpen} 
  style={{ 
    marginTop: "10px", 
    width: "180px", 
    borderRadius: "30px", 
    backgroundColor: "#6d28d9", // Tailwind's purple-600 hex color
    color: "white",
    border: "none",
    padding: "10px 20px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
    textAlign: "center",
  }}
>
    {isLang ==='eng' ?(
        <>
        Try Now
        </>
    ):(
        <>
جرب الآن
        </>
    )}
</button>
  </div>
</div>



<div className='catelogAITexContainer'>
  <div className='catelogAIText'>
    {isLang === 'eng' ? (
      <>
        <p>AI-assisted Image to Sketch Converter Tailored to Your Needs</p>
        <p>Easily find your perfect photo sketch effect that maximizes the enchanting flavor of your photos with our range of effects from our image to sketch converter. From the mesmerizing pencil sketch to the artistic ink effect, we've got you all covered!</p>
      </>
    ) : (
      <>
        <p>محول الصور إلى رسومات بمساعدة الذكاء الاصطناعي مصمم حسب احتياجاتك</p>
        <p>ابحث بسهولة عن تأثير رسم الصورة المثالي الذي يعزز نكهة صورك الساحرة من خلال مجموعة من التأثيرات من محول الصورة إلى الرسم. من الرسم الرصاصي المدهش إلى التأثيرات الفنية بالحبر، لدينا كل ما تحتاجه!</p>
      </>
    )}
  </div>
</div>

<div className='catelogAITexContainer '>
  <div style={{ textAlign: isLang === 'eng' ? 'left' : 'right', direction: isLang === 'eng' ? 'ltr' : 'rtl' }} className='w-[1200px] pb-10 text-lg'>
    {isLang === 'eng' ? (
      <>
        <p className='text-center text-2xl font-bold py-2'>Make a Promotional Video in 3 Simple Steps</p>
        <p><strong>1. Include Media:</strong> Compile images or movies from stock libraries or computers into the scenario. Add some effects if you like as well.</p>
        <p><strong>2. Personalize:</strong> For more customization, add narration, music, and text to your advertisement. Choose different styling fonts and bright colors.</p>
        <p><strong>3. Export:</strong> You may share your promotional media on the internet or download it in different resolutions and ratios by clicking the download option and exporting it to your computer or sharing it on any platform.</p>
      </>
    ) : (
      <>
        <p className='text-center text-2xl font-bold py-2'>أنشئ فيديو ترويجي في 3 خطوات بسيطة</p>
        <p><strong>1. قم بتضمين الوسائط:</strong> قم بتجميع الصور أو الأفلام من المكتبة أو أجهزة الكمبيوتر في السيناريو. أضف بعض التأثيرات إذا أردت أيضًا.</p>
        <p><strong>2. إضفاء الطابع الشخصي:</strong> لمزيد من التخصيص، أضف السرد والموسيقى والنص إلى إعلانك. اختر خطوط تصميم مختلفة وألوان زاهية.</p>
        <p><strong>3. التصدير:</strong> يمكنك مشاركة الوسائط الترويجية الخاصة بك على الإنترنت أو تنزيلها بدرجات دقة ونسب ارتفاع مختلفة من خلال النقر على خيار التنزيل وتصديرها إلى جهاز الكمبيوتر الخاص بك أو مشاركتها على أي منصة.</p>
      </>
    )}
  </div>
</div>






<div className='cardContainer' > 
 <div>
    <div>
    <img src={`${resume7}`} />
    </div>
    <div>
        <p>Pencil Drawing</p>
        <p>Convert photo to pencil sketch online free and add extra vibrant and artistic vibe with a single-click.</p>
    </div>
 </div>


 <div>
    <div>
    <img src={`${resume7}`} />
    </div>
    <div>
        <p>Pencil Drawing</p>
        <p>Convert photo to pencil sketch online free and add extra vibrant and artistic vibe with a single-click.</p>
    </div>
 </div>

 <div>
    <div>
    <img src={`${resume7}`} />
    </div>
    <div>
        <p>Pencil Drawing</p>
        <p>Convert photo to pencil sketch online free and add extra vibrant and artistic vibe with a single-click.</p>
    </div>
 </div>




</div>
<Footer />

    </>
  )
}

export default Catelog